<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/materialList' }">物料</el-breadcrumb-item>
                <el-breadcrumb-item>物料{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdown>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNaturalNumber } from '@/js/common.js';

export default {
    name: 'materialEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.initFormData();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                material_type_rid: {
                    request_uri: 'materialTypes',
                    title: '物料类型',
                    ref: 'material_type_rid_ref',
                    display_name: 'name',
                    type: 'dropdown'
                },
                dedicated_product_rid: {
                    request_uri: 'dropdownProducts',
                    title: '专属产品',
                    ref: 'dedicated_product_rid_ref',
                    display_name: 'name',
                    type: 'dropdown'
                },
                dedicated_product_licence_rid: {
                    request_uri: 'productLicencesDropdown',
                    title: '专属产品批文',
                    ref: 'dedicated_product_licence_rid_ref',
                    display_name: 'licence_product_name',
                    type: 'dropdown'
                }
            };
        },
        initFormRule() {
            this.rules = {
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                // quality_assurance_code: [{ required: true, message: '请输入QA代码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                // common_name: [{ required: true, message: '请输入通用名', trigger: 'blur' }],
                // quality_assurance_name: [{ required: true, message: '请输入QA名称', trigger: 'blur' }],
                material_type_rid: [{ required: true, message: '请选择物料类型', trigger: 'blur' }],
                min_validity_months: { validator: checkNaturalNumber, trigger: 'blur' },
                inspection_Interval: { validator: checkNaturalNumber, trigger: 'blur' }
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                code: this.data.code || '',
                quality_assurance_code: this.data.quality_assurance_code || '',
                name: this.data.name || '',
                common_name: this.data.common_name || '',
                quality_assurance_name: this.data.quality_assurance_name || '',
                specification: this.data.specification || '',
                quality_assurance_specification: this.data.quality_assurance_specification || '',
                unit: this.data.unit || '',
                material_type_rid: this.data.material_type_rid || '',
                dedicated_product_rid: this.data.dedicated_product_rid || '',
                dedicated_product_licence_rid: this.data.dedicated_product_licence_rid || '',
                tax_code: this.data.tax_code || '',
                min_validity_months: this.data.min_validity_months || 0,
                inspection_Interval: this.data.inspection_Interval || 0
            };
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).material;
            delete this.colData['created_at'];
            delete this.colData['updated_at'];
            delete this.colData['rid'];
            delete this.colData['material_type_name'];
            delete this.colData['dedicated_product_name'];
            delete this.colData['dedicated_product_licence_name'];
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/materialList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .materialDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'materialUpdate';
            } else {
                uri = 'materialInsert';
            }

            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>